import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAHc8_ycpMrcgwrQiBFtNRwa0IPEtpqYa8",
  authDomain: "wemojave-command-center.firebaseapp.com",
  projectId: "wemojave-command-center",
  storageBucket: "wemojave-command-center.firebasestorage.app",
  messagingSenderId: "472792133731",
  appId: "1:472792133731:web:25fa3fe131ddffdd6cc856",
  measurementId: "G-8QZJQE0PJX"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
